import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import StampedeFormEmbed from './stampede-form';

const Newsletter = ({ button, placeholder, smallprint }) => {
	const [isSuccess, setSuccess] = useState(false);
	const [isError, setError] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [message, setMessage] = useState('');

	const submitNewsletterSignup = async (values) => {
		let email = values.email;
		try {
			const response = await fetch('/.netlify/functions/subscribe', {
				method: 'POST',
				body: new URLSearchParams({
					email,
				}),
			});
			const data = await response.text();
			if (response.ok) {
				setError(false);
				setSuccess(true);
			} else {
				setError(true);
				setSuccess(false);
			}
		} catch (err) {
			setError(true);
			setSuccess(false);
		}
	};

	return (
		<div
			className={`newsletter ${isSuccess ? 'success-true' : ''} ${
				isError ? 'error-true' : ''
			}`}
		>
			{/* <StampedeFormEmbed /> */}
			<Formik
				initialValues={{
					email: '',
					gdpr: false,
					checked: [],
				}}
				validate={(values) => {
					const errors = {};
					if (!values.email) {
						errors.email = 'required';
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
							values.email
						)
					) {
						errors.email = 'Invalid Email Address';
					}
					if (!values.gdpr) {
						errors.gdpr = 'required';
					}
					return errors;
				}}
				onSubmit={(values) => {
					setSubmitting(true);
					setTimeout(() => {
						submitNewsletterSignup(values);
					}, 400);
				}}
			>
				{() => (
					<Form>
						<div className='form-container'>
							<div className='field-container signup-container'>
								<Field
									className='input-title'
									type='email'
									name='email'
									placeholder={placeholder}
								/>
								<ErrorMessage
									name='email'
									component='span'
									className='error'
								/>
								<button
									className='btn btn--large'
									type='submit'
									disabled={isSubmitting}
								>
									<span className='btn-text'>{button}</span>
								</button>
							</div>
							<label className='field-container checkbox'>
								<Field type='checkbox' name='gdpr' />
								<div className='checkbox_indicator'></div>
								<div className='small-print'>{smallprint}</div>
								<ErrorMessage
									className='error'
									name='gdpr'
									component='span'
								/>
							</label>
						</div>
					</Form>
				)}
			</Formik>
			<div
				className={`return-message ${isSuccess ? 'is-success' : ''} ${
					isError ? 'is-error' : ''
				}`}
			>
				<div className='message message-success'>
					<h4>Thanks for signing up!</h4>
				</div>
				<div className='message message-error'>
					<h4>Woops! Looks like there was a problem... {message}</h4>
				</div>
			</div>
		</div>
	);
};
export default Newsletter;
